<script>
import {VueMaskDirective as mask} from 'v-mask'
import service from '../../../../domain/leiloes/services'
import * as Status from '../../../../domain/leiloes/helpers/LoteStatus'
import BtnStatus from './BtnStatus.vue'
import BtnStatusConfirmar from './ConfirmStatus'
import ACL from '../../../../domain/acl/tmp-acl'
import { mapGetters } from 'vuex'
import Desistencias from './includes/Desistencias'
import BtnNovoValorLanceConfirmar from './ConfirmAlteracaoValorLance'
import AlterarValorLance from './AlterarValorLance'

export default {
  components: {
    AlterarValorLance,
    BtnNovoValorLanceConfirmar,
    Desistencias,
    BtnStatus,
    BtnStatusConfirmar
  },
  nome: 'lote',
  directives: {mask},
  data () {
    return {
      lote: null,
      isUploadingFoto: false,
      lances: null,
      lancesLoading: false,
      videoDestaque: ''
    }
  },
  computed: {
    getStatus () {
      return Status.Status
    },
    comissao () {
      let comissao = Number(this.lote.leilao.comissao)
      let valorArremate = Number(this.lote.valorArremate)
      return valorArremate * (comissao / 100)
    },
    porcentagemAvaliacao () {
      let tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0
      let avaliacao = typeof this.lote.valorAvaliacao !== 'undefined' ? this.lote.valorAvaliacao : 0
      if (tabelaFipe > 0 && avaliacao > 0) {
        return this.round((avaliacao / tabelaFipe) * 100, 2)
      }
      return 0
    },
    porcentagemMinimo () {
      let tabelaFipe = typeof this.lote.valorTabelaFipe !== 'undefined' ? this.lote.valorTabelaFipe : 0
      let minimo = typeof this.lote.valorMinimo !== 'undefined' ? this.lote.valorMinimo : 0
      if (tabelaFipe > 0 && minimo > 0) {
        return this.round((minimo / tabelaFipe) * 100, 2)
      }
      return 0
    },
    ACL () {
      return ACL
    },
    ...mapGetters(['isLogged', 'currentUser'])
  },
  mounted () {
    window.addEventListener('resize', this.init)
  },
  activated () {
  },
  created () {
    this.load()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.init)
  },
  deactivated () {
    this.$destroy() // no keep-alive
  },
  watch: {},
  methods: {
    load () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos o lote')
      service.findLote(this.$route.params.leilao, this.$route.params.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.lote = response.data
          this.videoDestaque = this.lote.videoDestaque
          this.init()
          this.carregaLances()
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    init () {
      this.$nextTick(() => {
        let tableLancesHead = this.$el.querySelector('#tableLancesHead')
        let tableLancesBody = this.$el.querySelector('#tableLances')
        console.log(tableLancesBody.clientWidth, tableLancesHead.clientWidth)
        tableLancesHead.style.width = tableLancesBody.clientWidth + 'px'
      })
    },
    carregaLances () {
      this.lancesLoading = true
      service.getLoteLances(this.lote.leilao.id, this.lote.id)
        .then((response) => {
          this.lancesLoading = false
          this.lances = response.data.lances
        })
        .catch((error) => {
          this.lancesLoading = false
          alert('Não foi possível carregar os lances')
          console.log(error)
        })
    },
    round: function (number, precision) {
      let factor = Math.pow(10, precision)
      let tempNumber = number * factor
      let roundedTempNumber = Math.round(tempNumber)
      return roundedTempNumber / factor
    },
    print: function () {
      window.print()
    },
    HelperCondicao (v) {
      return Status.Condicao[v]
    },
    Status () {
      return Status
    },
    confirmarAlteracaoStatus (v) {
      this.$refs.confirmarStatus.open(v, this.lote.status, (newStatus) => {
        let oldStatus = this.lote.status
        this.lote.status = newStatus
        service.atualizaStatusLote(this.lote.leilao.id, this.lote.id, newStatus)
          .then((response) => {
            // nothing to do
          })
          .catch((response) => {
            window.alert('Não foi possível atualizar o status, algum problema ocorreu, tente novamente.')
            this.lote.status = oldStatus
            console.log(response)
          })
      })
    },
    adjustFirstLetter (v) {
      return v.charAt(0).toLowerCase() + v.slice(1)
    },
    defineFotoDestaque (id, fotoIndex) {
      // Not work: https://stackoverflow.com/questions/42807888/vuejs-and-vue-set-update-array
      this.lote.fotos[fotoIndex].atualizandoDestaque = true
      service.setFotoDestaque(this.lote.leilao.id, this.lote.id, id)
        .then((response) => {
          delete this.lote.fotos[fotoIndex].atualizandoDestaque
          for (let foto in this.lote.fotos) {
            if (this.lote.fotos[foto].id === id) {
              this.lote.fotos[foto].destaque = true
            } else {
              this.lote.fotos[foto].destaque = false
            }
          }
        })
        .catch((response) => {
          delete this.lote.fotos[fotoIndex].atualizandoDestaque
          window.alert('Não foi possível atualizar a imagem para destaque, algum problema ocorreu, tente novamente.')
          console.log(response)
        })
    },
    uploadFotoLote (e) {
      this.isUploadingFoto = true
      let formData = new FormData()
      formData.append('file', e.target.files[0], e.target.files[0].name)
      service.uploadFotoLote(this.lote.leilao.id, this.lote.id, formData)
        .then((response) => {
          this.isUploadingFoto = false
          // this.$set(this.lote.fotos, response.data)
          this.lote.fotos = response.data
          console.log(response)
        })
        .catch((response) => {
          this.isUploadingFoto = false
          window.alert('Não foi possível fazer o upload da foto do lote, algum problema ocorreu, tente novamente.')
          console.log(response)
        })
    },
    removeFoto (id) {
      // TODO: Confirm
      let nodeFoto = this.$el.querySelector('#ltFoto' + id)
      nodeFoto.classList.add('hide')
      let parent = nodeFoto.parentNode
      service.deleteFotoLote(this.lote.leilao.id, this.lote.id, id)
        .then((response) => {
          parent.removeChild(nodeFoto)
          console.log(response)
        })
        .catch((response) => {
          window.alert('Não foi possível deletar a foto do lote, algum problema ocorreu, tente novamente.')
          nodeFoto.classList.remove('hide')
          console.log(response)
        })
    },
    atualizaDestaque () {
      service.atualizaDestaque(this.lote.leilao.id, this.lote.id, this.lote.destaque)
        .then((response) => {
          console.log(response)
        })
        .catch((response) => {
          window.alert('Não foi possível atualizar o destaque, algum problema ocorreu, tente novamente.')
          this.lote.destaque = !this.lote.destaque
          console.log(response)
        })
    },
    editar () {
      this.$router.push({name: 'lotes.editar', params: {id: this.lote.id}})
    },
    salvarVideo () {
      let videos = this.videoDestaque
      service.updateVideoDestaque(this.lote.id, videos)
        .then((response) => {
          alert('Video atualizado com sucesso')
        })
        .catch((response) => {
          alert('Erro ao atualizar o vídeo')
        })
    },
    deletarLance (id) {
      var r = confirm('Tem certeza que deseja deletar este lance?')
      if (r) {
        var motivo = prompt('Informe o motivo que levou a deletar este lance:')
        this.$loaderOverlay.open().message('Deletando lance...')
        service.deleteLance(id, motivo)
          .then((response) => {
            this.$loaderOverlay.hide()
            alert('Lance deletado com sucesso')
            this.carregaLances()
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            alert('Erro ao deletar o lance')
            alert(response.data.errors)
            console.log(response)
          })
      }

      return
    },
    deletarTodosLances (id) {
      var r = confirm('Tem certeza que deseja deletar todos os lances deste lote?')
      if (r) {
        var motivo = prompt('Informe o motivo que levou a deletar todos os lances:')
        this.$loaderOverlay.open().message('Deletando lances...')
        service.deleteAllLances(id, motivo)
          .then((response) => {
            this.$loaderOverlay.hide()
            alert('Lances deletados com sucesso')
            this.carregaLances()
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            alert('Erro ao deletar o lance')
            alert(response.data.errors)
            console.log(response)
          })
      }

      return
    },
    desistencia (id) {
      let r = confirm('Tem certeza que deseja registrar desistência na venda deste lote para o arrematante? O arrematante será informado por e-mail.')
      if (r) {
        let motivo = prompt('Informe o motivo que levou a registrar a desistência:')
        this.$loaderOverlay.open().message('Registrando desistência...')
        service.desistenciaLote(id, motivo)
          .then((response) => {
            this.$loaderOverlay.hide()
            alert('Desistência registrada com sucesso')
            this.load()
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            alert('Erro ao registrar a desistência')
            alert(response.data.errors)
            console.log(response)
          })
      }

      return
    },
    alterarValorLance (lance) {
      this.$refs.alterarValorLance.open(lance)
    },
    confirmarAlteracaoValorLance ({lance, valor: novoValor}) {
      this.$refs.confirmarNovoValorLance.open(lance, novoValor, () => {
        this.$loaderOverlay.open().message('Alterando valor do lance, aguarde')
        service.alterarValorLance(lance.id, novoValor)
        .then(response => {
          console.log(response)
          alert('Lance alterado com sucesso!')
          this.load()
        })
        .catch(error => {
          this.$loaderOverlay.hide()
          alert('Erro ao alterar o lance')
          alert(error.data.errors)
          console.log(error)
          this.$loaderOverlay.hide()
        })
      })
    },
    emailViewLoad () {
      return void (0)
    },
    emailViewEnviarEmail () {
      return void (0)
    },
    excluirLote (e) {
      if (parseInt(this.lote.leilao.status) === 6) {
        alert('Não é possível excluir lotes durante o pregão do leilão.')
        return
      }
      this.$confirm.open('Tem certeza que deseja excluir este lote de forma definitiva? Todos os lances, fotos, histórico de cadastro em favoritos e quaisquer outras informações relacionadas a este lote serão excluídas.', {
        message: 'Excluir',
        color: 'btn-danger'
      }, 'Cancelar', null, (v) => {
        if (v === false) return

        console.log('Excluindo lote...')
        this.$loaderOverlay.open().message('Excluindo lote')
        service.excluirLotes(this.lote.leilao.id, [this.lote.id])
          .then((response) => {
            this.$loaderOverlay.hide()
            this.$router.back() // .replace({name: 'leiloes.visualizar', params: {id: this.lote.leilao.id}})
          })
          .catch((response) => {
            this.$refs.changeStatus.close()
            window.responseError(response)
            console.log(response)
          })
      })
    }
  }
}
</script>

<template>
  <transition name="slide">
    <div v-if="lote !== null" class="content-transition">
      <btn-status-confirmar :Status="getStatus" ref="confirmarStatus"></btn-status-confirmar>
      <btn-novo-valor-lance-confirmar ref="confirmarNovoValorLance"></btn-novo-valor-lance-confirmar>
      <alterar-valor-lance ref="alterarValorLance" @novoValorLance="confirmarAlteracaoValorLance"></alterar-valor-lance>
      <div class="fade-in-down">
        <div class="bg-light lter b-b wrapper-md">
          <div class="row">
            <div class="col-md-6">
              <img :src="lote.urlMin" width="150" class="pull-left m-r">
              <h1 class="m-n font-thin h3">Lote #{{ lote.numero }}</h1>
              <h1 class="m-n font-thin h3">{{ lote.titulo }}</h1>
              <span class="label no-radius bg-dark">{{ lote.tipo ? lote.tipo.nome : '' }}</span>
              <span class="label m-l-n-xxs no-radius bg-success ">{{ lote.marca ? lote.marca.nome : '' }}</span>
              <!--<span class="label m-l-n-xxs no-radius bg-white ">{{ lote.comitente.pessoa.nome }}</span>-->
            </div>
            <div class="col-md-6">
              <div class="visible-xs m-t-lg"></div>
              <u-button class="btn btn-sm btn-info pull-right pull-none-xs hidden-print" tabindex="1"
                        @click.prevent="print">Imprimir
              </u-button>
              <u-button class="btn btn-sm btn-danger pull-right pull-none-xs m-r-sm hidden-print" tabindex="1" @click.prevent="excluirLote"
                        v-if="ACL.check('deletar_lance', currentUser.id)">
                Excluir
              </u-button>
              <u-button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="editar">
                Editar
              </u-button>
              <btn-status v-if="ACL.check('alterar_status_lote', currentUser.id)" :Status="getStatus" :value="lote.status" @input="confirmarAlteracaoStatus"
                          class="pull-right pull-none-xs m-r-sm hidden-print"></btn-status>
              <router-link :to="{name: 'leiloes.visualizar', params: {id: lote.leilao.id}}"
                           class="pull-right pull-none-xs hidden-print m-t-xs m-r"
                           style="clear: left"><strong class="label no-radius bg-info">Voltar</strong> para a tela do
                leilão
              </router-link>
            </div>
          </div>
        </div>
        <div class="wrapper-md">
          <div v-if="lote.arremate" class="alert alert-info">
            Lote arrematado por <a href="javascript:void(0)">{{ lote.arremate.arrematante.pessoa.nome }}</a>
            ({{ lote.arremate.arrematante.apelido }}),
            {{ adjustFirstLetter(moment(lote.arremate.dataArremate.date).format('LLLL'))
            }}, por <strong>R$ {{ lote.valorArremate | moeda }}</strong>.
            <br>
            Situação: <strong>{{ Status().StatusArremate[lote.arremate.status] }}</strong>
            <div class="m-t-sm">
              <a class="btn btn-danger btn-xs" @click="desistencia(lote.id)">Registrar Desistência</a>
            </div>
          </div>
          <div class="wrapper-sm bg-white m-b" v-if="lote.comitente">
            <img :src="lote.comitente.imagem" width="100" class="m-r">
            {{ lote.comitente.pessoa.nome }}
          </div>
          <div class="wrapper-sm bg-white m-b" v-else>
            Lote sem comitente
          </div>

          <div class="wrapper-sm no-padder m-b">
            <div class=" bg-black">
              <div class="wrapper-sm bg-dark font-bold text-uppercase">Lances</div>
              <div class="bg-black pos-rlt" id="tableLancesHead">
                <table class="table table-black bg-black m-b-none">
                  <thead>
                  <tr>
                    <th style="width: 25%">Data</th>
                    <th style="width: 25%">Apelido</th>
                    <th style="width: 25%">Valor</th>
                    <th style="width: 25%"></th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="scroll-black scroll-lote">
                <table class="table table-black" id="tableLances" style="margin-top: -36px">
                  <thead>
                  <tr>
                    <th style="width: 25%">Data</th>
                    <th style="width: 25%">Apelido</th>
                    <th style="width: 25%">Valor</th>
                    <th style="width: 25%"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(lance, index) in lances">
                    <td>{{ moment(lance.data.date).format('L') }} {{ moment(lance.data.date).format('LTS') }}</td>
                    <td>
                      <router-link target="_blank"
                                   :to="{name: 'arrematantes.visualizar', params: {id: lance.arrematanteId}}">{{
                          lance.apelido }}
                      </router-link>
                    </td>
                    <td>R$ {{ lance.valor | moeda }}</td>
                    <th>
                      <a v-if="ACL.check('deletar_lance', currentUser.id)" @click="deletarLance(lance.id)" class="text-danger" style="color:#ff6362">Deletar</a>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <a v-if="ACL.check('deletar_lance', currentUser.id) && index === 0" @click="alterarValorLance(lance)" class="text-danger" style="color:#ff6362">Alterar valor</a>
                    </th>
                  </tr>
                  <tr v-if="(!lances || lances.length === 0) && !lancesLoading">
                    <td colspan="4" class="no-borders" style="border-bottom: none"><span class="text-danger">Nenhum lance</span>
                    </td>
                  </tr>
                  <tr v-if="lancesLoading">
                    <td colspan="4" class="no-borders text-center" style="border-bottom: none"><i
                      class="fa fa-spin fa-spinner m-t fa-2x"></i></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
          <a v-if="ACL.check('deletar_lance', currentUser.id)" @click="deletarTodosLances(lote.id)" class="btn btn-danger m-b">Deletar todos os lances</a>

          <desistencias :lote="lote.id" />


          <div class="row">
            <div class="col-xs-12 col-md-8">
              <p>
                ID: <strong>{{ lote.id }}</strong> <br>
                Número: <strong>{{ lote.numero }}</strong> <br>
                Interno: <strong>{{ lote.syncId }}</strong> {{ lote.syncExtra }}<br>
                Condição: <strong>{{ Status().Condicao[lote.condicao] }}</strong> <br>
                Acessórios: <strong>{{ lote.acessorios }}</strong> <br><br>
                Tipo de bem: <strong>{{ lote.tipo ? lote.tipo.nome : '' }}</strong><br>
                Marca: <strong>{{ lote.marca ? lote.marca.nome : '' }}</strong><br>
              </p>
              <div v-if="lote.modelo">
                Modelo: <strong>{{ lote.modelo.modelo ? lote.modelo.modelo.nome : '' }}</strong><br>
                Fabricação: <strong>{{ lote.modelo.anoFabricacao }}</strong><br>
                Ano: <strong>{{ lote.modelo.anoModelo }}</strong><br><br>
              </div>
              <p>
                Informações adicionais:<br>
              </p>
              <div v-for="tipoValor in lote.tipoCampos">
                {{ tipoValor.tipo.nome }}: <strong>{{ tipoValor.valor }}</strong><br>
              </div>
              <br>
              <p>
                Observações:<br><br>
                {{ lote.observacao }}
              </p>

              <div class="wrapper-sm b b-2x">
                <div class="m-b"><strong>Configurações para o site</strong></div>
                <div>
                  <p>Apelido para URL amígável: <strong><a class="hover-items">{{ lote.slug }} <i
                    class="fa fa-edit show-hover"></i></a></strong></p>
                  <p>URL pública: <strong><a
                    :href="'https://www.rogeriomenezes.com.br/lote/' + lote.id + '/' + lote.slug"
                    target="_blank">{{ 'https://www.rogeriomenezes.com.br/lote/' + lote.id + '/' + lote.slug
                    }}</a></strong></p>
                  <p>Destaque: <span class="visible-print-inline-block">{{ lote.destaque ? 'Sim' : 'Não' }}</span>
                    <u-button-group @change="atualizaDestaque" class="hidden-print" v-model="lote.destaque"
                                    :options="[{label: 'Sim', value: true, class: 'btn-success'},{label: 'Não', value: false, class: 'btn-danger'}]"></u-button-group>
                  </p>

                  Vídeos:
                  <div class="row">
                    <div class="col-sm-6"><input class="form-control" v-model="videoDestaque"/></div>
                    <div class="col-sm-6">
                      <button class="btn btn-success inline" @click="salvarVideo">Salvar</button>
                    </div>
                  </div>
                  para mais de um vídeo, separe-os por ,

                </div>
              </div>

            </div>
            <div class="col-xs-12 col-md-4 text-right">

              <table class="table table-condensed">
                <tbody>
                <tr>
                  <td>% FIPE - Avaliação:</td>
                  <td><strong>{{ porcentagemAvaliacao }}%</strong></td>
                </tr>
                <tr>
                  <td>Valor Avaliação:</td>
                  <td><strong>R$ {{ lote.valorAvaliacao | moeda }} {{ porcentagemAvaliacao }}%</strong></td>
                </tr>
                <tr>
                  <td>% FIPE - Mínimo:</td>
                  <td><strong>{{ porcentagemMinimo }}%</strong></td>
                </tr>
                <tr>
                  <td>Valor Mínimo:</td>
                  <td><strong>R$ {{ lote.valorMinimo | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Valor Tabela Fipe:</td>
                  <td><strong>R$ {{ lote.valorTabelaFipe | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Valor Inicial:</td>
                  <td><strong>R$ {{ lote.valorInicial | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Valor Meta:</td>
                  <td><strong>R$ {{ lote.valorMeta | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Valor Incremento:</td>
                  <td><strong>R$ {{ lote.valorIncremento | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Valor Remoção:</td>
                  <td><strong>R$ {{ lote.valorRemocao | moeda }}</strong></td>
                </tr>
                <tr v-if="lote.valorArremate > 0">
                  <td>Valor Arremate:</td>
                  <td class="bg-success"><strong>R$ {{ lote.valorArremate | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>Taxa de Arremate:</td>
                  <td><strong>R$ {{ lote.valorTaxaArremate | moeda }}</strong></td>
                </tr>
                <tr>
                  <td>ICMS:</td>
                  <td><strong>{{ lote.icms }}%</strong></td>
                </tr>
                <tr>
                  <td>ISS:</td>
                  <td><strong>{{ lote.icms }}%</strong></td>
                </tr>
                <tr>
                  <td>Comissão:</td>
                  <td><strong>{{ lote.leilao.comissao }}%</strong></td>
                </tr>
                <tr>
                  <td>Valor Comissão:</td>
                  <td><strong>R$ {{ comissao | moeda }}</strong></td>
                </tr>
                </tbody>
              </table>

            </div>
            <div class="col-xs-12">
              <div class="m-b m-t-lg">Fotos</div>
              <div class="fotos-flex">
                <div v-for="(foto, index) in lote.fotos" :id="'ltFoto' + foto.id" class="foto">
                  <a :href="foto.url" target="_blank"> <img :src="foto.urlMin" class="img-responsive"></a>
                  <span v-if="foto.destaque" class="destaque">Destaque</span>
                  <div class="btn-actions">
                    <!--<u-button class="btn btn-xs btn-block btn-default"><i class="fa fa-photo"></i> Maximizar</u-button>-->
                    <u-button @click="defineFotoDestaque(foto.id, index)" class="btn btn-xs btn-block btn-success">
                      <span v-if="!foto.atualizandoDestaque">Tornar Destaque</span>
                      <span v-if="foto.atualizandoDestaque">Trabalhando nisso...</span>
                    </u-button>
                    <u-button @click="removeFoto(foto.id)" class="btn btn-xs btn-block btn-danger">Remover</u-button>
                  </div>
                </div>
                <div class="foto">
                  <u-button v-if="!isUploadingFoto" class="btn btn-info fileContainer hidden-print"><i
                    class="fa fa-upload m-r-sm"></i> Adicionar nova foto <input
                    @change="uploadFotoLote" accept="image/*" type="file"/></u-button>
                  <div v-if="isUploadingFoto" class="text-center"><i class="fa fa-spin fa-spinner"></i> <br>Enviando
                    foto
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// VisualizarLote.vue?93bf2862